import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { FileCaptureService } from '../service/file-capture.service';
import { FileServiceService } from '../service/file-service.service';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input()
  isDashboard: boolean = false;

  isInstructionsEnabled: boolean = false;
  instructionText: string = '';

  private readonly instructionEnabledKey = 'fc_instruction_enabled';
  private readonly instructionTextKey = 'fc_instruction_text';
  private readonly knownRoutes = new Set([
    'reference',
    'file-upload',
    'review-files',
    'confirmation',
    'email-auth',
    'routing'
  ]);

  constructor(private fcservice: FileCaptureService, public service: FileServiceService, private router: Router, private modalService: NgbModal, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.loadInstructionsFromCache();
    const securityCode = this.resolveSecurityCode();
    if (securityCode && (!this.instructionText || !this.service.fileCaptureConfig)) {
      this.loadInstructionsFromApi(securityCode);
    }
  }

  showInstructions(): void {
    if (!this.instructionText) {
      return;
    }

    const modalRef = this.modalService.open(InstructionsComponent, { size: 'lg', ariaLabelledBy: 'Instructions' });
    modalRef.componentInstance.name = this.instructionText;
  }

  private loadInstructionsFromCache(): void {
    this.isInstructionsEnabled = window.localStorage.getItem(this.instructionEnabledKey) === 'true';
    this.instructionText = window.localStorage.getItem(this.instructionTextKey) || '';
  }

  private resolveSecurityCode(): string {
    const storedCode = window.localStorage.getItem('securityCode') || '';
    if (storedCode) {
      return storedCode;
    }

    const pathSegment = this.router.url.split('?')[0].split('/').filter(Boolean)[0] || '';
    if (!pathSegment) {
      return '';
    }

    if (this.knownRoutes.has(pathSegment.toLowerCase())) {
      return '';
    }

    window.localStorage.setItem('securityCode', pathSegment);
    return pathSegment;
  }

  private loadInstructionsFromApi(securityCode: string): void {
    this.fcservice.getFileCaptureConfig(securityCode).subscribe({
      next: (config) => {
        const instructionEnabled = !!(config && (config.InstructionEnabled ?? config.instructionEnabled));
        const instruction = (config?.Instruction || config?.instruction || '').toString();
        const formattedInstruction = instruction ? instruction.replace('<img ', '<img title="Header" ') : '';

        this.service.setConfig(config);
        this.isInstructionsEnabled = instructionEnabled;
        this.instructionText = formattedInstruction;

        window.localStorage.setItem(this.instructionEnabledKey, String(instructionEnabled));
        window.localStorage.setItem(this.instructionTextKey, formattedInstruction);
      },
      error: () => {
        this.isInstructionsEnabled = false;
        this.instructionText = '';
      }
    });
  }

  get headerEnabled(): boolean {
    return this.service.getConfigBoolean('HeaderEnabled', false);
  }

  get headerText(): string {
    return this.service.getConfigValue('HeaderText', '');
  }

  get headerHtml(): SafeHtml {
    const html = this.headerText.replace(/<img /g, '<img title="Header Image" alt="Header Image" ');
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}
